import { render, staticRenderFns } from "./aliCodeValidate.vue?vue&type=template&id=0ffac826&scoped=true"
import script from "./aliCodeValidate.vue?vue&type=script&lang=js"
export * from "./aliCodeValidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffac826",
  null
  
)

export default component.exports